import { makeStyles } from "@material-ui/core";

export const useQuotedMessageStyles = makeStyles((theme) => ({  quotedContainerLeft: {
    margin: "0 0 6px 0", // CORRIGIDO: removido margens negativas que causavam overflow
    overflow: "hidden",
    backgroundColor: theme.mode === "light" ? "#f0f0f0" : "#1d282f",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
    maxWidth: "100%", // ADICIONADO: garantir que não exceda o container pai
    width: "100%", // ADICIONADO: ocupar toda largura disponível
    boxSizing: "border-box", // ADICIONADO: incluir padding/border no cálculo da largura
  },

  quotedContainerRight: {
    margin: "0 0 6px 0", // CORRIGIDO: removido margens negativas que causavam overflow
    overflowY: "hidden",
    backgroundColor: theme.mode === "light" ? "#cfe9ba" : "#025144",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
    maxWidth: "100%", // ADICIONADO: garantir que não exceda o container pai
    width: "100%", // ADICIONADO: ocupar toda largura disponível
    boxSizing: "border-box", // ADICIONADO: incluir padding/border no cálculo da largura
  },  quotedMsg: {
    padding: "8px 10px", // AJUSTADO: reduzido padding vertical para melhor proporção
    maxWidth: "calc(100% - 4px)", // CORRIGIDO: descontar largura da barra lateral (4px)
    width: "calc(100% - 4px)", // AJUSTADO: descontar largura da barra lateral
    minWidth: 0, // ADICIONADO: permitir encolhimento para textos longos
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    wordBreak: "break-word", // MANTIDO: quebrar palavras longas
    boxSizing: "border-box", // MANTIDO: incluir padding no cálculo da largura
    flex: 1, // ADICIONADO: ocupar espaço disponível no container flex
  },

  quotedMsgRight: {
    padding: "8px 10px", // AJUSTADO: reduzido padding vertical para melhor proporção
    maxWidth: "calc(100% - 4px)", // CORRIGIDO: descontar largura da barra lateral (4px)
    width: "calc(100% - 4px)", // AJUSTADO: descontar largura da barra lateral
    minWidth: 0, // ADICIONADO: permitir encolhimento para textos longos
    height: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word", // MANTIDO: quebrar palavras longas
    boxSizing: "border-box", // MANTIDO: incluir padding no cálculo da largura
    flex: 1, // ADICIONADO: ocupar espaço disponível no container flex
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#388aff",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  // Estilos específicos para elementos de mídia dentro de mensagens citadas
  quotedMediaContainer: {
    maxWidth: "100%",
    overflow: "hidden",
  },

  quotedVideo: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "150px", // Altura máxima para vídeos em mensagens citadas
  },

  quotedImage: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "150px", // Altura máxima para imagens em mensagens citadas
    objectFit: "cover",
  },

  quotedDownloadButton: {
    fontSize: "0.8rem",
    padding: "4px 8px",
    minWidth: "auto",
  },
}));
